import React, { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/lib/i18n";

const LocaleContext = createContext(null);

// Approximate DOP<->USD rate; UI conversion only
const DOP_PER_USD = 60;

export function LocaleProvider({ children }) {
  const [lang, setLang] = useState(() => (typeof window !== "undefined" ? localStorage.getItem("t2c_lang") : null) || "es");
  const [currency, setCurrency] = useState(() => (typeof window !== "undefined" ? localStorage.getItem("t2c_currency") : null) || "USD");

  useEffect(() => { localStorage.setItem("t2c_lang", lang); }, [lang]);
  useEffect(() => { localStorage.setItem("t2c_currency", currency); }, [currency]);

  const t = (path) => {
    const keys = path.split(".");
    let cursor = dict[lang];
    for (const k of keys) {
      if (cursor && k in cursor) cursor = cursor[k];
      else return path;
    }
    return cursor;
  };

  const formatPrice = (amount, sourceCurrency = "USD") => {
    if (amount == null) return "";
    let usd = sourceCurrency === "USD" ? amount : amount / DOP_PER_USD;
    let value = currency === "USD" ? usd : usd * DOP_PER_USD;
    try {
      return new Intl.NumberFormat(lang === "es" ? "es-DO" : "en-US", {
        style: "currency",
        currency: currency === "USD" ? "USD" : "DOP",
        maximumFractionDigits: 0,
      }).format(value);
    } catch {
      return `${currency} ${Math.round(value).toLocaleString()}`;
    }
  };

  return (
    <LocaleContext.Provider value={{ lang, setLang, currency, setCurrency, t, formatPrice }}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error("useLocale must be used within LocaleProvider");
  return ctx;
}
